jQuery.feature_import("js-nutrients-admin",
  () => require("./nutrients-admin.js"),
  mod => mod.feature_js_nutrients_admin
);